import { render, staticRenderFns } from "./AffBillingApp.vue?vue&type=template&id=44a176c4&scoped=true&"
import script from "./AffBillingApp.vue?vue&type=script&lang=js&"
export * from "./AffBillingApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a176c4",
  null
  
)

export default component.exports